import makeApi from "../../libs/axios/api";
import { PhotoUploadPayload, ValidateTokenPayload } from "../../types/photoUpload";
const apiPromise = makeApi();

const validateToken = async (data: ValidateTokenPayload): Promise<any>  => {
  const api = await apiPromise;
  const path = `/validate-upload-token`;
  return api
    .post(path, data).then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Delete failed:", error);
      throw error;
    });
};

const photoUploadSave = async (data: PhotoUploadPayload): Promise<any>  => {
  const api = await apiPromise;
  const path = `/upload-pictures`;
  const formData = new FormData();
  
  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === "object" && key !== "OrderAttachments") {
      Object.entries(value).forEach(([subKey, subValue]) => {
        formData.append(`${key}.${subKey}`, String(subValue));
      });
    } else if (key === "OrderAttachments" && Array.isArray(value)) {
      value.forEach((attachment, index) => {
        if (attachment) {
          Object.entries(attachment).forEach(
            ([attachmentKey, attachmentValue]) => {
              formData.append(
                `${key}[${index}].${attachmentKey}`,
                attachmentValue instanceof File
                  ? attachmentValue
                  : String(attachmentValue)
              );
            }
          );
        }
      });
    } else {
      formData.append(key, String(value));
    }
  });

  return api.post(path, formData).then((response) => {
    return response;
  })
  .catch((error) => {
      console.error("Delete failed:", error);
      throw error;
    });
};

export { validateToken, photoUploadSave };